import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { DriverManagementPage } from './DriverManagementPage';

export const DriversPage: React.FC = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="management" replace />} />
      <Route path="management" element={<DriverManagementPage />} />
    </Routes>
  );
};